import { render, staticRenderFns } from "./teacher-permission-bind.vue?vue&type=template&id=43b92284&scoped=true"
import script from "./teacher-permission-bind.vue?vue&type=script&lang=js"
export * from "./teacher-permission-bind.vue?vue&type=script&lang=js"
import style0 from "./teacher-permission-bind.vue?vue&type=style&index=0&id=43b92284&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b92284",
  null
  
)

export default component.exports